import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import { HomePage } from "./pages/HomePage";
import { OverviewPage } from "./pages/OverviewPage";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import { ProtectedRoute, LoadingScreen } from "./components";
import { AppRoutes as AppRoutesPaths } from "./constants";
import { LanguageProvider } from "./contexts/LanguageContext";
import { SnackbarProvider } from "./contexts/SnackbarContext";

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      {/* Public home page */}
      <Route path={AppRoutesPaths.home} element={<HomePage />} />

      {/* Public overview/search results page */}
      <Route path={AppRoutesPaths.overview} element={<OverviewPage />} />

      {/* Login page - redirect to home if already logged in */}
      <Route
        path={AppRoutesPaths.login}
        element={
          user ? (
            <Navigate to={AppRoutesPaths.dashboard} replace />
          ) : (
            <LoginPage />
          )
        }
      />

      {/* Protected dashboard */}
      <Route
        path={AppRoutesPaths.dashboard}
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />

      {/* Email verification */}
      <Route path={AppRoutesPaths.verifyEmail} element={<VerifyEmailPage />} />

      {/* Catch-all redirect to home */}
      <Route path="*" element={<Navigate to={AppRoutesPaths.home} replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <SnackbarProvider>
        <AppRoutes />
      </SnackbarProvider>
    </LanguageProvider>
  );
}
